import { createAction, handleActions } from 'redux-actions'
import client from 'common/util/http'
import cache from 'common/util/cache'
import { replace, push } from 'react-router-redux'
import { loadStart, loadFinish, loadError } from 'common/redux/root'

const RESET = 'onboard/RESET'
const LOAD = 'onboard/LOAD'
const MULTISELECT = 'onboard/MULTISELECT'

const load = createAction(LOAD)
const reset = createAction(RESET)
const multiselect = createAction(MULTISELECT)

const defaultErrorHandler = dispatch => error => {
  dispatch(loadError(error))
  return Promise.reject(error)
}

const defaultLoadHandler = dispatch => response => {
    dispatch(load(response))
    dispatch(loadFinish())
    return Promise.resolve(response)
}

export function updatePrice(key, enabled) {
  return dispatch => {
    dispatch(multiselect({multiselect:'price_categories', key, enabled}))
  }
}

export function updateClientCategories(key, enabled) {
  return dispatch => {
    dispatch(multiselect({multiselect:'client_categories', key, enabled}))
  }
}

const initialState = {
  price_categories: {
    "100-150": true,
    "150-300": true,
    "300-500": true,
    "500-1M": true,
    "1M+": true,
  },
  client_categories: {
    "buyer": true,
    "buyer-seller": true,
    "investor": true,
    "seller": true,
  },
}

export default handleActions({
    [LOAD]: (state, { payload }) => ({ ...state, ...payload }),
    [RESET]: (state, { payload }) => ({ ...initialState }),
    [MULTISELECT]: (state, { payload }) => {
      const multiselect =  { ...state[payload.multiselect] }
      if (payload.enabled) {
        multiselect[payload.key] = true
      } else {
        delete multiselect[payload.key]
      }

      return {...state, [payload.multiselect]: multiselect}
    },
}, initialState)
